import React from "react";
import styled from "styled-components";

const Container = styled.div<{ width: number }>`
    padding: 0 10px;
    width: ${(p) => p.width}px;
    font-family: urdu;
    font-weight: 500;
    font-size: 14px;
    color: #bf4543;
`;

export default function ErrorMessage({
    errorMsg,
    width,
}: {
    errorMsg: string;
    width: number;
}) {
    return <Container width={width}>{errorMsg}</Container>;
}
